import { Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import "./styles/App.css";
import Dashboard from "./components/Dashboard";

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </div>
  );
}

export default App;
